import * as Apis from "@api";

import useConfigQuery from "./useConfigQuery";

const useGlobalQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default useGlobalQuery;
